const ContactMeta = require('./ContactMeta.jsx');
const LineItemCell = require('../invoice/LineItemCell.jsx');
const LineItems = require('../invoice/LineItems.jsx');
const Meta = require('./Meta.jsx');
const Name = require('../utility/Name.jsx');
const Totals = require('../common/Totals.jsx');

// LEGACY
const Items = require('../invoice/Items.jsx');
const Notes = require('../invoice/Notes.jsx');

const Blocks = {
    get: (group, data) => [
        {
            id: 'offerSeparator',
            dataType: 'separator', 
            display: 'Offer', 
            group
        },
        {
            id: Name.Block.Client.ContactMeta,
            component: ContactMeta.Component,
            config: {
                Block: ContactMeta.TypeConfig.panel.block(),
                Style: ContactMeta.TypeConfig.panel.style(),
                Description: ContactMeta.TypeConfig.panel.description(),
                Label: ContactMeta.TypeConfig.panel.label(),
                Value: ContactMeta.TypeConfig.panel.value()
            },
            display: 'Contact Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.Date,
            component: Meta.V2.Date.Component,
            config: {
                Block: Meta.V2.Date.TypeConfig.panel.block(),
                Style: Meta.V2.Date.TypeConfig.panel.style(),
                Description: Meta.V2.Date.TypeConfig.panel.description(),
                Label: Meta.V2.Date.TypeConfig.panel.label(),
                Value: Meta.V2.Date.TypeConfig.panel.value()
            },
            display: 'Offer Date',
            group,
            image: ''
        },
        {
            id: Name.Block.ValidThrough,
            component: Meta.V2.ValidThrough.Component,
            config: {
                Block: Meta.V2.ValidThrough.TypeConfig.panel.block(),
                Style: Meta.V2.ValidThrough.TypeConfig.panel.style(),
                Description: Meta.V2.ValidThrough.TypeConfig.panel.description(),
                Label: Meta.V2.ValidThrough.TypeConfig.panel.label(),
                Value: Meta.V2.ValidThrough.TypeConfig.panel.value()
            },
            display: 'Valid Through',
            group,
            image: ''
        },
        {
            id: Name.Block.Company.StaffName,
            component: Meta.V2.Staff.Component,
            config: {
                Block: Meta.V2.Staff.TypeConfig.panel.block(),
                Style: Meta.V2.Staff.TypeConfig.panel.style(),
                Description: Meta.V2.Staff.TypeConfig.panel.description(),
                Label: Meta.V2.Staff.TypeConfig.panel.label('Prepared By:'),
                Value: Meta.V2.Staff.TypeConfig.panel.value(),
                Visibility: Meta.V2.Staff.TypeConfig.panel.visibility()
            },
            display: 'Staff Name',
            group,
            image: ''
        },
        {
            id: Name.Block.Notes,
            component: Meta.V2.Notes.Component,
            config: {
                Block: Meta.V2.Notes.TypeConfig.panel.block(),
                Style: Meta.V2.Notes.TypeConfig.panel.style(),
                Description: Meta.V2.Notes.TypeConfig.panel.description(),
                Label: Meta.V2.Notes.TypeConfig.panel.label('Notes'),
                Value: Meta.V2.Notes.TypeConfig.panel.value(),
                Visibility: Meta.V2.Notes.TypeConfig.panel.visibility('Offer Notes')
            },
            display: 'Offer Notes',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.List,
            component: LineItems.Component,
            config: {
                Block: LineItems.TypeConfig.panel.block(),
                Style: LineItems.TypeConfig.panel.style(),
                Visibility: LineItems.TypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: LineItemCell.Container.TypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Line Items',
            group,
            image: ''
        },
        {
            id: Name.Block.Total.Discount,
            component: Totals.DiscountV2.Component,
            config: {
                Block: Totals.DiscountV2.TypeConfig.panel.block(),
                Style: Totals.DiscountV2.TypeConfig.panel.style(),
                Description: Totals.DiscountV2.TypeConfig.panel.description(),
                Label: Totals.DiscountV2.TypeConfig.panel.label(),
                Value: Totals.DiscountV2.TypeConfig.panel.value(data)
            },
            display: 'Discount',
            group,
            image: ''
        },
        {
            id: 'taxes',
            component: Totals.TaxesV2.Component,
            config: {
                Block: Totals.TaxesV2.TypeConfig.panel.block(),
                Style: Totals.TaxesV2.TypeConfig.panel.style(),
                Description: Totals.TaxesV2.TypeConfig.panel.description(),
                Label: Totals.TaxesV2.TypeConfig.panel.label(),
                Value: Totals.TaxesV2.TypeConfig.panel.value(data)
            },
            display: 'Taxes',
            group,
            image: ''
        },
        {
            id: 'shipping',
            component: Totals.ShippingV2.Component,
            config: {
                Block: Totals.ShippingV2.TypeConfig.panel.block(),
                Style: Totals.ShippingV2.TypeConfig.panel.style(),
                Description: Totals.ShippingV2.TypeConfig.panel.description(),
                Label: Totals.ShippingV2.TypeConfig.panel.label(),
                Value: Totals.ShippingV2.TypeConfig.panel.value(data)
            },
            display: 'Shipping',
            group,
            image: ''
        },
        {
            id: 'grandTotal',
            component: Totals.GrandTotalV2.Component,
            config: {
                Block: Totals.GrandTotalV2.TypeConfig.panel.block(),
                Style: Totals.GrandTotalV2.TypeConfig.panel.style(),
                Description: Totals.GrandTotalV2.TypeConfig.panel.description(),
                Label: Totals.GrandTotalV2.TypeConfig.panel.label('Total'),
                Value: Totals.GrandTotalV2.TypeConfig.panel.value(data)
            },
            display: 'Grand Total',
            group,
            image: ''
        }
    ],
    content: {
        // [Name.Block.Inventory.List]: LineItemCell.Container.Blocks
    },
    tokens: (id, data) => {
        switch (id) {
            case Name.Block.Client.ContactMeta:
                return ContactMeta.Tokens();
            case Name.Block.Company.StaffName:
                return Meta.V2.Staff.Tokens();
            case Name.Block.Date:
                return Meta.V2.Date.Tokens();
            case Name.Block.Inventory.Meta:
                return LineItemCell.Meta.Tokens(data);
            case Name.Block.Total.Discount:
                return Totals.DiscountV2.Tokens(data);
            case Name.Block.Total.GrandTotal:
                return Totals.GrandTotalV2.Tokens(data);
            case Name.Block.Total.Shipping:
                return Totals.ShippingV2.Tokens(data);
            case Name.Block.Total.Taxes:
                return Totals.TaxesV2.Tokens(data);
            case Name.Block.ValidThrough:
                return Meta.V2.ValidThrough.Tokens();
        }
    },

    legacy: [
        { display: 'Offer Data Blocks', type: 'header' },
        {
            id: 'date',
            component: Meta.Date.Component,
            config: {
                Block: Meta.Date.TypeConfig.panel.block(),
                Style: Meta.Date.TypeConfig.panel.style()
            },
            display: 'Offer Date',
            image: ''
        },
        {
            id: 'validThrough',
            component: Meta.ValidThrough.Component,
            config: {
                Block: Meta.ValidThrough.TypeConfig.panel.block(),
                Style: Meta.ValidThrough.TypeConfig.panel.style()
            },
            display: 'Valid Through',
            image: ''
        },
        {
            id: 'contactName',
            component: Meta.ContactName.Component,
            config: {
                Block: Meta.ContactName.TypeConfig.panel.block(),
                Style: Meta.ContactName.TypeConfig.panel.style()
            },
            display: 'Contact Name',
            image: ''
        },
        {
            id: 'contactCompany',
            component: Meta.ContactCompany.Component,
            config: {
                Block: Meta.ContactCompany.TypeConfig.panel.block(),
                Style: Meta.ContactCompany.TypeConfig.panel.style()
            },
            display: 'Contact Company',
            image: ''
        },
        {
            id: 'staff',
            component: Meta.Staff.Component,
            config: {
                Block: Meta.Staff.TypeConfig.panel.block(),
                Visibility: Meta.Staff.TypeConfig.panel.visibility(),
                Style: Meta.Staff.TypeConfig.panel.style()
            },
            display: 'Staff Name',
            image: ''
        },
        {
            id: 'notes',
            component: Notes.Component,
            config: {
                Block: Notes.TypeConfig.panel.block(),
                Includes: Notes.TypeConfig.panel.includes(),
                Style: Notes.TypeConfig.panel.style()
            },
            display: 'Notes',
            image: ''
        },
        { display: 'Table Data Blocks', type: 'header' },
        {
            id: 'lineItems',
            component: Items.Component,
            config: {
                Block: Items.TypeConfig.panel.block(),
                Meta: Items.TypeConfig.panel.meta(),
                Includes: Items.TypeConfig.panel.includes(),
                Style: Items.TypeConfig.panel.style(),
                Format: Items.TypeConfig.panel.format()
            },
            display: 'Line Items',
            image: ''
        },
        { display: 'Totals Blocks', type: 'header' },
        {
            id: 'discount',
            component: Totals.Discount.Component,
            config: {
                Block: Totals.Discount.TypeConfig.panel.block(),
                Style: Totals.Discount.TypeConfig.panel.style(),
                Format: Totals.Discount.TypeConfig.panel.format()
            },
            display: 'Discount',
            image: ''
        },
        {
            id: 'taxes',
            component: Totals.Taxes.Component,
            config: {
                Block: Totals.Taxes.TypeConfig.panel.block(),
                Style: Totals.Taxes.TypeConfig.panel.style(),
                Format: Totals.Taxes.TypeConfig.panel.format()
            },
            display: 'Taxes',
            image: ''
        },
        {
            id: 'shipping',
            component: Totals.Shipping.Component,
            config: {
                Block: Totals.Shipping.TypeConfig.panel.block(),
                Includes: Totals.Shipping.TypeConfig.panel.includes(),
                Style: Totals.Shipping.TypeConfig.panel.style(),
                Format: Totals.Shipping.TypeConfig.panel.format()
            },
            display: 'Shipping',
            image: ''
        },
        {
            id: 'grandTotal',
            component: Totals.GrandTotal.Component,
            config: {
                Block: Totals.GrandTotal.TypeConfig.panel.block(),
                Style: Totals.GrandTotal.TypeConfig.panel.style(),
                Format: Totals.GrandTotal.TypeConfig.panel.format()
            },
            display: 'Grand Total',
            image: ''
        },
    ]
};

module.exports = {
    Blocks
};